// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24pq9","col":"styles_col__3_uZW"};